import { humanize } from '../lib/format';
import { phrase } from '../lib/i18n/runtime';

export type BadgeTone = 'ok' | 'down' | 'warn' | 'info' | 'neutral';

const TONE_ICONS: Readonly<Record<BadgeTone, string>> = {
  ok: '✓',
  down: '✕',
  warn: '!',
  info: 'i',
  neutral: '•',
};

/** Status is always conveyed by text plus a symbol, never by color alone. */
export function Badge({ tone, label }: { tone: BadgeTone; label: string }) {
  return (
    <span className={`badge badge--${tone}`}>
      <span aria-hidden="true">{TONE_ICONS[tone]}</span> {phrase(label)}
    </span>
  );
}

const STATUS_TONES: Readonly<Record<string, BadgeTone>> = {
  ACTIVE: 'ok',
  APPROVED: 'ok',
  ACCEPTED: 'ok',
  PENDING: 'info',
  DRAFT: 'info',
  PAUSED: 'warn',
  SUSPENDED: 'warn',
  INACTIVE: 'warn',
  CORRECTED: 'neutral',
  EXPIRED: 'neutral',
  RETIRED: 'neutral',
  DEPARTED: 'neutral',
  DEACTIVATED: 'down',
  REVOKED: 'down',
  DISCARDED: 'down',
};

export function StatusBadge({ status }: { status: string }) {
  return <Badge tone={STATUS_TONES[status] ?? 'neutral'} label={humanize(status)} />;
}
